import { AnimatePresence, motion } from 'framer-motion';

import { Photo } from '../Photo/Photo';
import { BgVideo } from '../BgVideo/BgVideo';
import { StartBgVideo } from '../StartBgVideo/StartBgVideo';

import styles from './Slideshow.module.css';
import logo from '../../assets/images/logo.webp';

const Slideshow = ({ currentMessage, message, rotateSign, duration }) => {
  const durationSec = duration / 1000;
  const endpointStart = 0.33;
  const exitDuration = 0.18 * durationSec;
  const allStartDuration = durationSec - exitDuration;
  const startDutation = allStartDuration * endpointStart;

  return (
    <div className={styles.wrapper}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={styles.logoBlock}
      >
        <img src={logo} alt="" className={styles.logo} />
      </motion.div>

      <AnimatePresence mode="wait">
        <div key={currentMessage.id} className={styles.photoBlock}>
          <Photo
            message={message}
            rotateSign={rotateSign}
            startDutation={startDutation}
          />
        </div>
      </AnimatePresence>

      <StartBgVideo />
      <BgVideo />
    </div>
  );
};

export default Slideshow;
